import apiInstance from './common.api';

export const getAuthRtk = async (data: { hash: string; node?: string }) => {
  return await apiInstance.post('/api/auth/hashlogin', data);
};
// http://localhost:3000/authorization/p1?hash_key=2h547Tgf5yGfd3453hfdjKjdshf4353h
